import { Component, OnInit, ViewChild } from "@angular/core";
import { Message } from "primeng/primeng";
import { Subscription } from "rxjs/Rx";
import {
  AccountService,
  AccountViewService,
  MfaOptionsViewService,
  MfaOptionsSaveService
} from "../account/account.service";
import {
  UserAccountSettingView,
  ContactInfo,
  SecurityInfo,
  PhoneInfo,
  DisplayTime,
  MfaSettings,
  MfaElectionModal,
  MfaElectionTypeEnum
} from "../account/model";
import { TimeService } from "../time.service";
import { NgxTranslateService } from "../shared/ngx-translate.service";
@Component({
  moduleId: module.id.toString(),
  template: require('./security-settings.component.html')
})
export class SecuritySettingsComponent implements OnInit {
  busy: Subscription;
  messages: Message[] = [];
  canSave: boolean = false;
  settingView: UserAccountSettingView;
  mfaSettingsView: MfaSettings;
  tempToTpKey: string;
  @ViewChild("MySecurity")
  mySecurity: any;

  constructor(
    private accountService: AccountService,
    private accountViewService: AccountViewService,
    private mfaViewService: MfaOptionsViewService,
    private mfaSaveService: MfaOptionsSaveService,
    private timeService: TimeService,
    private translateService : NgxTranslateService
  ) {}

  ngOnInit(): void {
    this.busy = this.mfaViewService.getMfaSettingsView().subscribe(
        (      sv: MfaSettings) => {
        this.mfaSettingsView = sv;
        this.mfaSettingsView.MfaHasChange = false;
        this.mfaSettingsView.MfaHasErrors = false;
        this.mfaSettingsView.MfaStatus = this.timeService.getMFAStatus(
          sv.MfaEnabled
        );
        this.mfaSettingsView.EmailChecked = sv.EmailStatus === 1;
        this.mfaSettingsView.EmailCheckedInitial = this.mfaSettingsView.EmailChecked
        this.mfaSettingsView.PhoneChecked = sv.PhoneStatus === 1;
        this.mfaSettingsView.PhoneCheckedInitial = this.mfaSettingsView.PhoneChecked
        this.mfaSettingsView.GoogleAuthChecked =
          sv.GoogleAuthenticatorStatus === 1;
        this.mfaSettingsView.GoogleAuthCheckedInitial = this.mfaSettingsView.GoogleAuthChecked
        this.mfaSettingsView.PhoneDisabled = sv.PhoneStatus === 0;
        this.mfaSettingsView.GoogleAuthDisabled =
          sv.GoogleAuthenticatorStatus === 0;
        this.mfaSettingsView.EmailDisabled = sv.ForceEmailMfaEnabled;
        this.mfaSettingsView.MfaErrorMsg = this.translateService.getText("Secure_MFA_Atleast_Two_Options_Select_Error", "At least two MFA options must be selected");
        this.mfaSettingsView.MfaSelectedOptions = 0;
        if (this.mfaSettingsView.EmailChecked) {
          this.mfaSettingsView.MfaSelectedOptions =
            this.mfaSettingsView.MfaSelectedOptions + 1;
        }
        if (this.mfaSettingsView.GoogleAuthChecked) {
          this.mfaSettingsView.MfaSelectedOptions =
            this.mfaSettingsView.MfaSelectedOptions + 1;
        }
        if (this.mfaSettingsView.PhoneChecked) {
          this.mfaSettingsView.MfaSelectedOptions =
            this.mfaSettingsView.MfaSelectedOptions + 1;
        }

      },
        (      error: any) => {
        this.messages.push({
          severity: "error",
          detail: this.translateService.getText("Secure_MFA_Data_Retrieving_Error", "There was a problem retrieving your mfa security settings."),
          summary: this.translateService.getText("Common.ErrorSummary", "Error!")
        });
      }
    );
    this.busy = this.accountViewService.getSettingsView().subscribe(
        (      sv: UserAccountSettingView) => {
        this.settingView = sv;
        let time: number =
          sv.security.sessionTimeout > 0
            ? sv.security.sessionTimeout
            : this.timeService.defaultTimeInMin;
        this.settingView.security.sliderTime = this.timeService.convertMinToHours(
          time
        );
        this.settingView.security.displayTime = this.timeService.getDisplayTime(
          this.settingView.security.sliderTime
        );
        this.settingView.security.sliderTimeInitial = this.settingView.security.sliderTime;
        this.canSave = true;
      },
        (      error: any) => {
        this.messages.push({
          severity: "error",
          detail: this.translateService.getText("Secure_SecureSetting_Data_Retrieving_Error", "There was a problem retrieving your security settings."),
          summary: this.translateService.getText("Common.ErrorSummary", "Error!")
        });
      }
    );
  }

    onSubmit(): void {
    this.canSave = false;
    let mfaSelectedOptions = 0;
    if (this.mfaSettingsView.EmailChecked) {
        mfaSelectedOptions += 1;
    }
    if (this.mfaSettingsView.GoogleAuthChecked) {
        mfaSelectedOptions += 1;
    }
    if (this.mfaSettingsView.PhoneChecked) {
        mfaSelectedOptions += 1;
    }
    if (
        mfaSelectedOptions < 2 &&
        this.mfaSettingsView.MfaEnabled
    ) {
        this.mfaSettingsView.MfaHasErrors = true;
        this.messages.push({
            severity: "error",
            detail: this.mfaSettingsView.MfaErrorMsg,
            summary: this.translateService.getText("Common.ErrorSummary", "Error!")
        });
        return;
    } else {
        this.mfaSettingsView.MfaHasErrors = false;
        this.canSave = true;
    }

    // Note: Taking advantage of the inheritence relationship that
    // UserAccountSettingView has with UserAccountSetting so that
    // settingView can be passed as a UserAccountSetting even though
    // it is a UserAccountSettingView.
      if (!this.mfaSettingsView.MfaHasErrors && this.mfaSettingsView.MfaHasChange) {
          this.busy = this.accountService.saveSettings(this.settingView).subscribe(
              (s: { contact: ContactInfo; }) => {
                  this.settingView.contact = s.contact;
                  this.messages.push({
                      severity: "info",
                      detail: this.translateService.getText("Secure_SecureSetting_Data_Saved_Msg", "Your security settings were saved."),
                      summary: this.translateService.getText("Common.Success", "Success")
                  });
              },
              (error: { source: { [x: string]: any; }; title: string; detail: string; }) => {
                  if (error.source) {
                      for (var err in error.source) {
                          this.messages.push({
                              severity: "error",
                              detail: error.source[err],
                              summary: error.title == "" ? this.translateService.getText("Common.Error", "An error occurred.") : error.title
                          });
                      }
                  } else
                      this.messages.push({
                          severity: "error",
                          detail:
                              error.detail == ""
                                  ? this.translateService.getText("Secure_SecureSetting_Data_Save_Error_Msg", "There was a problem saving your security settings.")
                                  : error.detail,
                          summary: error.title == "" ? this.translateService.getText("Common.Error", "An error occurred.") : error.title
                      });
              }
          );
      }

    if (this.mfaSettingsView.MfaHasChange && !this.mfaSettingsView.MfaHasErrors) {
        let mfaObject = this.generateMfaObject(this.mfaSettingsView);
        this.busy = this.mfaSaveService
            .saveMfaOptions(
                mfaObject,
                this.mfaSettingsView.MfaHasChange,
                this.mfaSettingsView.MfaHasErrors
            )
            .subscribe(
                (s: any) => {
                    this.messages.push({
                        severity: "info",
                        detail: this.translateService.getText("Secure_MFA_Data_Saved_Msg", "Your MFA settings were saved."),
                        summary: this.translateService.getText("Common.Success", "Success")
                    });

                    if (this.mfaSettingsView.GoogleAuthChecked) {
                        this.mfaSettingsView.GoogleAuthenticatorStatus = 1;
                    } else if (!this.mfaSettingsView.GoogleAuthChecked) {
                        this.mySecurity.ReinitalizeWizardComponent();
                        this.mfaSettingsView.GoogleAuthenticatorStatus = 2;
                    }
                    this.mfaSettingsView.EmailCheckedInitial = this.mfaSettingsView.EmailChecked;
                    this.mfaSettingsView.PhoneCheckedInitial = this.mfaSettingsView.PhoneChecked;
                    this.mfaSettingsView.GoogleAuthCheckedInitial = this.mfaSettingsView.GoogleAuthChecked;
                    this.mfaSettingsView.MfaHasChange = false;
                },
                (error: { source: { [x: string]: any; }; title: string; detail: string; }) => {
                    this.canSave = true;
                    if (error.source) {
                        for (var err in error.source) {
                            this.messages.push({
                                severity: "error",
                                detail: error.source[err],
                                summary: error.title == "" ? this.translateService.getText("Common.Error", "An error occurred.") : error.title
                            });
                        }
                    } else
                        this.messages.push({
                            severity: "error",
                            detail:
                                error.detail == ""
                                    ? this.translateService.getText("Secure_MFA_Data_Save_Error_Msg", "There was a problem saving your MFA settings.")
                                    : error.detail,
                            summary: error.title == "" ? this.translateService.getText("Common.Error", "An error occurred.") : error.title
                        });
                }
            );
    }
    }

    cannotSubmit(): boolean {
        if (!this.mfaSettingsView) {
            return true; 
        }
        return !this.mfaSettingsView.MfaHasChange || this.mfaSettingsView.MfaHasErrors;
    }

    cannotReset(): boolean {
        if (!this.mfaSettingsView) {
            return true;
        }
        return !this.mfaSettingsView.MfaHasChange;
    }

    onReset(): void {
        if (!this.mfaSettingsView || !this.settingView) {
            return;
        }
        this.mfaSettingsView.EmailChecked = this.mfaSettingsView.EmailCheckedInitial;
        this.mfaSettingsView.PhoneChecked = this.mfaSettingsView.PhoneCheckedInitial;
        this.mfaSettingsView.GoogleAuthChecked = this.mfaSettingsView.GoogleAuthCheckedInitial;
        this.settingView.security.sliderTime = this.settingView.security.sliderTimeInitial;

        this.mfaSettingsView.MfaHasChange = false;
        this.mfaSettingsView.MfaHasErrors = false;
    }

  private generateMfaObject(setting: MfaSettings): MfaElectionModal {
    let mfaObject = new MfaElectionModal();
    if (!setting.MfaEnabled) {
      mfaObject.MfaElection = MfaElectionTypeEnum.None;
    } else {
      if (
        setting.EmailChecked &&
        setting.GoogleAuthChecked &&
        setting.PhoneChecked
      ) {
        mfaObject.MfaElection = MfaElectionTypeEnum.EmailPhoneAndGoogleAuthenticator;
        mfaObject.TotpPin = this.tempToTpKey;
      } else if (setting.EmailChecked && setting.GoogleAuthChecked) {
        mfaObject.MfaElection = MfaElectionTypeEnum.EmailAndGoogleAuthenticator;
        mfaObject.TotpPin = this.tempToTpKey;
      } else if (setting.EmailChecked && setting.PhoneChecked) {
        mfaObject.MfaElection = MfaElectionTypeEnum.EmailAndPhone;
      } else if (setting.GoogleAuthChecked && setting.PhoneChecked) {
        mfaObject.MfaElection = MfaElectionTypeEnum.PhoneAndGoogleAuthenticator;
        mfaObject.TotpPin = this.tempToTpKey;
      } else if (setting.GoogleAuthChecked) {
        mfaObject.MfaElection = MfaElectionTypeEnum.GoogleAuthenticator;
        mfaObject.TotpPin = this.tempToTpKey;
      } else if (setting.EmailChecked) {
        mfaObject.MfaElection = MfaElectionTypeEnum.Email;
      }
    }
    return mfaObject;
  }

  SetKeyValue(key: string = "") {
    this.tempToTpKey = key;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/security/security-settings.component.ts